import { render, staticRenderFns } from "./GetSelectedDispatchesData.vue?vue&type=template&id=6d52ca38&scoped=true&"
import script from "./GetSelectedDispatchesData.vue?vue&type=script&lang=js&"
export * from "./GetSelectedDispatchesData.vue?vue&type=script&lang=js&"
import style0 from "./GetSelectedDispatchesData.vue?vue&type=style&index=0&id=6d52ca38&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d52ca38",
  null
  
)

export default component.exports